import i18n from 'i18next';
import { translationSuffixes } from '../constants';
import { findIndex, pick } from 'lodash-es';

export const getObjPropRecursively = (obj, props) => {
  let result = obj;
  if (props && obj) {
    const propsPath = props.split('.');
    propsPath.forEach(subProp => {
      result =
        result != null && result.hasOwnProperty(subProp)
          ? result[subProp]
          : null;
    });
  }
  return result;
};

export const setObjProp = (obj, props, value) => {
  let innerObj = obj;
  if (props && obj) {
    const propsPath = props.split('.');
    propsPath.forEach((subProp, index) => {
      if (index == propsPath.length - 1) {
        innerObj[subProp] = value;
      } else {
        if (!innerObj.hasOwnProperty(subProp) || innerObj[subProp] == null)
          innerObj[subProp] = {};
        innerObj = innerObj[subProp];
      }
    });
  }
  return obj;
};

export const pushToObjProp = (obj, props, value) => {
  let innerObj = obj;
  if (props && obj) {
    const propsPath = props.split('.');
    propsPath.forEach((subProp, index) => {
      if (index == propsPath.length - 1) {
        if (!innerObj.hasOwnProperty(subProp)) innerObj[subProp] = [];
        innerObj[subProp].push(value);
      } else {
        if (!innerObj.hasOwnProperty(subProp)) innerObj[subProp] = {};
        innerObj = innerObj[subProp];
      }
    });
  }
  return obj;
};

export const removeFromObjProp = (obj, props, indexToRemove) => {
  let innerObj = obj;
  if (props && obj) {
    const propsPath = props.split('.');
    propsPath.forEach((subProp, index) => {
      if (index == propsPath.length - 1) {
        innerObj[subProp].splice(indexToRemove, 1);
      } else {
        if (!innerObj.hasOwnProperty(subProp)) innerObj[subProp] = {};
        innerObj = innerObj[subProp];
      }
    });
  }
  return obj;
};

/**
 * Forms the translated placeholder, cannot be Component because it actually returns just a string
 * @param label
 * @param placeholder
 * @param t
 * @returns {*}
 */
export const getTranslatedPlaceholder = (label, placeholder) => {
	if (placeholder && i18n.exists(placeholder)) {
		return i18n.t(placeholder);
	} else if (label && i18n.exists(label + translationSuffixes.placeholder)) {
		return i18n.t(label + translationSuffixes.placeholder);
	} else {
		return placeholder;
	}
};

export const getErrorMessage = error => {
	if (
		error &&
		error.response &&
		error.response.data &&
		error.response.data.message &&
		error.response.data.message.startsWith('message.error')
	)
		return error.response.data.message;
	else if (error && error.message)
		return error.message;
	else if (typeof error === 'string' || error instanceof String)
		return error;
};


const mapRequiredSelectProps = (text, value, key) => {
	const newObj = {};
	newObj.text = text;
	newObj.value = value;
	newObj.key = key;
	return newObj;
};

const getObjPropsJoined = (object, props) => {
	let result = [];
	if (props)
		props.forEach(prop => {
			let v = getObjPropRecursively(object, prop);
			if (v) result.push(v);
		});
	else result.push(object);
	return result.join(' ,');
};

/**
 * @param list are all the available options
 * @param defaultValue is added as the only option if list is not declared, this allows the value to be displayed
 * @param text is the property to be displayed as text
 * @returns the available options mapped as required by select field component
 */
export const getOptions = (list, defaultValue = null, propsAsText = ['value'], getValueKey = o => (o.id ? o.id : o)) => {
	if (list) {
		return list.map(o =>
			mapRequiredSelectProps(getObjPropsJoined(o, propsAsText), getValueKey(o), getValueKey(o))
		);
	} else if (defaultValue) {
		return [defaultValue].map(o =>
			mapRequiredSelectProps(getObjPropsJoined(o, propsAsText), getValueKey(o), getValueKey(o))
		);
	} else return [];
};

export const updateByKey = (arr, updatedObject, matcherArgs) => {
	const data = [...arr];
	const idx = findIndex(data, pick(updatedObject, matcherArgs));
	data[idx] = updatedObject;
	return data;
};

export const arrayBufferToBase64 = arrayBuffer => {
	return `data:image/jpeg;base64,${window.btoa(new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), ''))}`;
}

export default {
	getObjPropRecursively,
	setObjProp,
	pushToObjProp,
	removeFromObjProp,
	getTranslatedPlaceholder,
	getErrorMessage,
	getOptions,
	updateByKey,
	arrayBufferToBase64
};
